<template>
  <div class="detailWrap">
    <div class="detailMain">
      <van-swipe
        :autoplay="3000"
        indicator-color="white"
        class="swiper-container"
        @change="onChange"
      >
        <van-swipe-item
          v-for="(item,index) in listData.goods_pic_list"
          :key="index"
          class="swiper-slide"
        >
          <img :src="item" alt />
        </van-swipe-item>
        <div
          class="custom-indicator swiper-pagination"
          slot="indicator"
        >{{ current + 1 }}/{{imgLength}}</div>
      </van-swipe>
      <div class="bigWrap">
        <div class="goodInformation">
          <div class="goodPrice">
            <p>
              <span>¥</span>
              <span>{{listData.cost_price}}</span>
              <span>进货价</span>
            </p>
            <p>
              <span>¥</span>
              <span>{{listData.sale_price}}</span>
              <span>建议售价</span>
            </p>
          </div>
          <div class="goodMark">
            <p>
              <span>市场价</span>
              <span>¥</span>
              <span>{{listData.market_price}}</span>
            </p>
          </div>
          <div class="goodDetail">
            <span>一件赚¥{{listData.gain_amount}}</span>
            <span>{{listData.name}}</span>
          </div>
        </div>
        <div class="goodAdvertisement">
          <img src="../image/regiment.png" alt />
        </div>
        <div class="spec">
          <p>
            <span>规格</span>
            <span>{{listData.specification}}</span>
          </p>
          <p>
            <span>库存</span>
            <span>{{listData.inventory}}</span>
          </p>
        </div>
        <!-- <div class="nbsp"></div> -->
        <div class="recommend">
          <p>推荐理由</p>
          <p class="static">{{listData.goods_message}}</p>
        </div>
      </div>
      <div class="detailImage" v-for="(item,index) in listData.detail_pic_list" :key="index">
        <img :src="item" />
      </div>
      <van-dialog v-model="successVisible">
        <p style=" text-align:center;padding:30px 20px;width:100%">已上架到团小蜜！快去小程序中查看吧~</p >
      </van-dialog>
      <van-dialog v-model="centerDialogVisible">
        <p style="text-align:center;padding:30px 20px;width:100%;">您还不是团长，添加微信「pursue5998」申请成为我们的团长吧！</p>
      </van-dialog>
       <van-dialog v-model="noShelf">
        <p style="text-align:center;padding:30px 20px;width:100%;">{{errorText}}</p>
      </van-dialog>
    </div>
    <div class="footer" @click="oneKeyRack" id="text">{{text}}</div>
  </div>
</template>
<script>

import axios from "axios";
import wx from "weixin-js-sdk";
import configUrl from "../config/config.js";

export default {
  mixins: [configUrl],
  data() {
    return {
      listData: {},
      goodId: "",
      goodName: "",
      goodPic: [],
      goodMessage: "",
      text: "一键上架",
      current: 0,
      imgLength: Number,
      successVisible: false,
      centerDialogVisible:false,
      noShelf: false,
      errorText: '',
    };
  },
  methods: {
    oneKeyRack() {
      if (this.text !== "一键上架") {
        return;
      }
      let url =
        this.getRedirectDomain() + `classify/#/detail?good_id=${this.goodId}`;
      let curUrl = url.replace("#", "%23");
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe10d406d3c94eded&redirect_uri=${curUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    },
    getGood() {
      axios
        .post(this.getDomain() + "goods/get_detail", {
          good_id: this.goodId
        })
        .then(res => {
          if (res.data.err_code === 0) {
            this.listData = res.data.content.detail_info;
            this.goodPic = res.data.content.detail_info.goods_pic_list[0];
            this.goodName = this.listData.name;
            this.imgLength = this.listData.goods_pic_list.length;
            this.goodMessage = this.listData.goods_message,
            this.wx_jssdk(this.goodId,this.goodPic,this.goodName,this.goodMessage);
          }
        });
    },
    addGroupBuy(code) {
      axios
        .post(this.getDomain() + "goods/add_group_buy", {
          good_id: this.goodId,
          code: code
        })
        .then(res => {
          console.log(res.data.content.desc,'res.data.content.desc')
          if (res.data.err_code === 0) {
            if (res.data.content.is_client === 1) {
              // 是团长
              this.successVisible = true;
            } else {
              //是团长  已经添加到小程序
              this.centerDialogVisible = true;
            }
          } else if (res.data.err_code === 20114) {
            this.text = res.data.content.desc;
            document.getElementById("text").style.backgroundColor = "#ccc";
          } else {
            this.noShelf = true;
            this.errorText = res.data.content.desc;
          }
        });
    },
    wx_jssdk(goodId,goodPic,goodName,goodMessage) {
      axios
        .post(this.getDomain() + "wx/get_signature", {
          url: window.location.href
        })
        .then(function(response) {
          if (response.data.err_code === 0) {
            wx.config({
              debug: false,
              appId: "wxe10d406d3c94eded",
              timestamp: response.data.content.timestamp,
              nonceStr: response.data.content.noncestr,
              signature: response.data.content.signature,
              jsApiList: [
                "updateAppMessageShareData",
                "updateTimelineShareData"
              ]
            });
            wx.ready(function() {
              wx.updateAppMessageShareData({
                title: goodName,
                desc:
                 goodMessage,
                link: "https://wxtxm.zidouchat.com/classify/?no_cache=" + Math.random() + "#/detail?good_id=" + goodId,
                imgUrl:
                  goodPic,
                success: function() {}
              });
              wx.updateTimelineShareData({
                title: goodName,
                desc:
                  goodMessage,
                link: "https://wxtxm.zidouchat.com/classify/?no_cache=" + Math.random() + "#/detail?good_id=" + goodId,
                imgUrl:
                  goodPic,
                success: function() {}
              });
            });
          }
        });
    },
    onChange(index) {
      this.current = index;
    }
  },
  created() {
    console.log(this.$route.query);
    this.goodId = this.$route.query.good_id;
    if (!this.goodId) {
      // TODO: 给一个 error 提示
      return;
    }
    this.getGood();
    let cUrl = window.location.href;
    if (cUrl.indexOf("code") > -1) {
      let code = cUrl.split("code=")[1].split("&state")[0];
      if (code) {
        this.addGroupBuy(code);
      }
    }
  },
  mounted() {
  },

};
</script>

<style lang="scss" scoped>
body,
html {
  width: 100%;
  height: 100%;
}
.detailWrap {
  width: 100%;
  height: 100%;
  display: flex;
  background: #f8f8f8;
  flex-direction: column;
}
.detailMain {
  flex: 1;
  max-width: 7.5rem;
  background: rgba(255, 255, 255, 1);
  padding-bottom: 2rem;
  .swiper-container {
    max-width: 7.5rem;
    height: 6rem;
    .swiper-slide {
      max-width: 7.5rem;
      height: 6rem;
      text-align: center;
      img {
        max-width: 7.5rem;
        height: 6rem;
        margin: 0 auto;
      }
    }
  }
  .bigWrap {
   
    background: #f8f8f8;
  }
  .goodInformation {
    background: white;
    padding: 0.3rem 0.32rem;
    border-radius: 0.2rem;
    box-shadow: 0rem -0.02rem .1rem 0rem rgba(0, 0, 0, 0.04);
    z-index: 2;
    position: relative;
    top: -0.1rem;
    left: 0;
    .goodPrice {
      display: flex;
      p:nth-child(1) {
        color: #e32124;
        span:nth-child(1) {
          font-size: 0.28rem;
        }
        span:nth-child(2) {
          font-size: 0.48rem;
          margin-right: 0.1rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 1.96rem;
          // display: inline-block;
        }
        span:nth-child(3) {
          width: 0.7rem;
          height: 0.28rem;
          // background: rgba(227, 33, 36, 1);
          padding: 0 0.1rem;
          background: rgba(227, 33, 36, 1);
          color: rgba(255, 255, 255, 1);
          margin-left: 0.12rem;
          font-size: 0.2rem;
          margin-right: 0.18rem;
        }
      }
      p:nth-child(2) {
        color: #f66c21;
        margin-left: 0.3rem;
        span:nth-child(1) {
          font-size: 0.28rem;
        }
        span:nth-child(2) {
          font-size: 0.48rem;
          margin-right: 0.1rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 1.96rem;
          // display: inline-block;
        }
        span:nth-child(3) {
          width: 0.92rem;
          height: 0.28rem;
          padding: 0 0.1rem;
          background: rgba(246, 108, 33, 1);
          color: rgba(255, 255, 255, 1);
          margin-left: 0.12rem;
          font-size: 0.2rem;
        }
      }
    }
    .goodMark {
      color: rgba(153, 153, 153, 1);
      margin: 0.14rem 0 0.16rem 0;
      p {
        span:nth-child(1) {
          font-size: 0.28rem;
          margin-right: 0.12rem;
        }
        span:nth-child(2) {
          font-size: 0.24rem;
        }
        span:nth-child(3) {
          font-size: 0.32rem;
        }
      }
    }
    .goodDetail {
      // margin-bottom: 0.3rem;
      span:nth-child(1) {
        width: 1.16rem;
        height: .32rem;
        border-radius: .04rem;
        padding: 0 0.12rem;
        background: rgba(227, 33, 36, 1);
        color: #ffffff;
        border-radius: 0.04rem;
        border: 0.02rem solid rgba(227, 33, 36, 1);
        font-size: 0.2rem;
        margin-right: 0.2rem;
      }
      span:nth-child(2) {
        font-size: 0.32rem;
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
      }
    }
  }
  .goodAdvertisement {
    margin: 0.2rem 0;
    background: white;
    padding: 0.2rem 0.32rem;
    border-radius: 0.2rem;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .spec {
    background: white;
    border-radius: 0.2rem;
    padding: 0.24rem 0.32rem;
    margin: 0.2rem 0;
    p:nth-child(1) {
      margin-bottom: 0.48rem;
      span:nth-child(1) {
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        font-size: 0.28rem;
        margin-right: 0.1rem;
      }
      span:nth-child(2) {
        font-size: 0.24rem;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
      }
    }
    p:nth-child(2) {
      span:nth-child(1) {
        font-weight: 500;
        color: rgba(0, 0, 0, 1);
        font-size: 0.28rem;
        margin-right: 0.1rem;
      }
      span:nth-child(2) {
        font-size: 0.24rem;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
      }
    }
  }

  .recommend {
    background: rgba(255, 255, 255, 1);
    padding: 0.26rem 0.32rem;
    border-top-left-radius: 0.2rem;
    border-top-right-radius: 0.2rem;
    p:nth-child(1) {
      text-align: center;
      font-size: 0.32rem;
      font-weight: 500;
      color: rgba(0, 0, 0, 1);
      margin-bottom: 0.24rem;
    }
    p:nth-child(2) {
      font-size: 0.28rem;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
  }
  .detailTime {
    width: 100%;
    height: 0.88rem;
    background: rgba(251, 237, 238, 1);
    margin: 0.14rem 0;
    font-size: 0.24rem;
    .image {
      width: 0.42rem;
      height: 0.42rem;
      border-radius: 0.06rem;
      line-height: 0.88rem;
      margin: 0.24rem 0.2rem 0.22rem 0.32rem;
      display: inline-block;
    }
    span {
      display: block;
      margin-top: 0.3rem;
      float: right;
      margin-right: 1.16rem;
      color: rgba(203, 41, 46, 1);
    }
  }
  .detailReason {
    width: 100%;
    // height: 3.12rem;
    background: rgba(255, 255, 255, 1);
    span:nth-child(1) {
      font-size: 0.32rem;
      display: block;
      padding: 0.32rem;
      padding-bottom: 0;
    }
    span:nth-child(2) {
      font-size: 0.32rem;
      display: block;
      padding: 0.32rem;
      font-weight: 400;
    }
  }
  .detailImage {
    width: 100%;
    img {
      width: 100%;
      display: block;
    }
  }
}
.footer {
  width: 100%;
  height: 1.12rem;
  background: rgba(203, 41, 46, 1);
  text-align: center;
  line-height: 1.12rem;
  color: white;
  font-weight: 500;
  font-size: 0.36rem;
  position: fixed;
  bottom: 0;
  left: 0;
}
</style>
<style lang="scss" scoped>
.swiper-pagination {
  width: 0.8rem;
  height: 0.4rem;
  background: rgba(0, 0, 0, 1);
  border-radius: 0.2rem;
  opacity: 0.2;
  line-height: 0.4rem;
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFangSC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  bottom: 0.76rem;
  left: 6.3rem;
  position: relative;
}
.static{
  white-space: pre-wrap;
}
</style>
